import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import FB_ICON from 'shared/assets/images/fb_icon.png';
import VIBER from 'shared/assets/images/viber_icon.png';
import WHATSAPP from 'shared/assets/images/whatsapp_icon.png';
import TELEGRAM from 'shared/assets/images/telegram_icon.png';
import s from './DealerSocials.css';

const isMobile = __APP__ === 'mobile';

class DealerSocials extends React.Component {
  static propTypes = {
    messengers: PropTypes.arrayOf(PropTypes.shape).isRequired,
  };
  static defaultProps = {};

  render() {
    const { messengers } = this.props;
    const messengersIcons = {
      telegram: TELEGRAM,
      viber: VIBER,
      'facebook-messenger': FB_ICON,
      whatsapp: WHATSAPP,
    };
    return (
      <div className={cx(s.root, { [s.mobileRoot]: isMobile })}>
        {messengers.map(item =>
          <a href={item.link} target="_blank" key={item.link}>
            <img
              src={messengersIcons[item.messenger]}
              alt=""
              className={cx(s.socialIcon, { [s.mobileSocIcon]: isMobile })}
            />
          </a>,
        )}
      </div>
    );
  }
}

export default withStyles(s)(DealerSocials);



// WEBPACK FOOTER //
// ./src/shared/components/DealerSocials/DealerSocials.js